import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { ArrowPathIcon } from '@heroicons/react/24/solid';

const ConditionNode: React.FC<NodeProps> = ({ data, selected }) => {
  return (
    <div
      className={`px-1 py-0.5 shadow-sm rounded bg-white border ${
        selected ? 'border-primary-500' : 'border-yellow-500'
      } transform rotate-45`}
      style={{ width: '40px', height: '40px' }}
    >
      <div className="transform -rotate-45 flex items-center justify-center h-full">
        <div className="flex flex-col items-center">
          <ArrowPathIcon className="w-3 h-3 text-yellow-600" />
          <div className="text-[9px] font-semibold text-gray-700">{data.label}</div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 bg-yellow-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
        style={{ top: '50%', left: '-8px' }}
        title="Input"
      />
      <Handle
        type="source"
        position={Position.Right}
        id="true"
        className="w-3 h-3 bg-green-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
        style={{ top: '30%', right: '-8px' }}
        title="True branch"
      />
      <Handle
        type="source"
        position={Position.Right}
        id="false"
        className="w-3 h-3 bg-red-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
        style={{ top: '70%', right: '-8px' }}
        title="False branch"
      />
    </div>
  );
};

export default ConditionNode;